let Table = mc.widgets.Table;
let Orderable = mc.widgets.Orderable;
let IconButton = mc.widgets.IconButton;
let FormControls = mc.widgets.FormControls;

let ActivityFormView = require("../view/ActivityFormView");

let StudyActivitiesList = function (props) {
  let cols = [
    {
      prop: "displayName",
      label: tx("name"),
      content: function (activity) {
        let editActivity = function () {
          ActivityFormView.open(activity, props.disabled || activity.pipelineIds.length > 0);
        };

        return <a onClick={editActivity}>{activity.displayName}</a>;
      },
      width: "35%",
      sort: false
    },
    {
      prop: "instructions",
      label: tx("instructions"),
      content: function (activity) {
        return activity.instructions;
      },
      width: "60%",
      sort: false,
      clip: true
    },
    {
      prop: "copy",
      label: "",
      content: function (activity) {
        return (
          <IconButton
            icon="copy"
            label={tx("copy")}
            onPress={() => props.onCopy(activity)}
            scale={0.9}
            disabled={props.disabled || activity.pipelineIds.length > 0}/>
        );
      },
      width: "5%",
      sort: false
    }
  ];

  return <Table data={props.activities} cols={cols} align="middle"/>;
};

let OrderableRow = function (props) {
  return (
    <div key={props.id}>
      {props.displayName}
    </div>
  );
};

let StudyActivitiesForm = function (props) {
  let rows = props.activities.filter((a) => a.mode === "SUPERVISED").map(function (activity) {
    return <OrderableRow key={activity.id} orderId={activity.id} displayName={activity.displayName}/>;
  });

  return (
    <div>
      <p>{tx("arrange_activities")}</p>
      <Orderable onOrder={props.onOrder}>
        {rows}
      </Orderable>
    </div>
  );
};

class StudyActivities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: [],
      submitting: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.editing !== this.props.editing && this.props.editing === true) {
      this.setState({
        order: this.props.activities.map((activity) => activity.id),
        submitting: false
      });
    }
  }

  cancel() {
    this.props.onCancel();
  }

  save() {
    this.setState({
      order: [],
      submitting: true
    });

    this.props.onSave(this.order(this.props.activities));
  }

  reorder(order) {
    this.setState({ order });
  }

  order(activities) {
    return this.state.order.map(function (orderId) {
      return activities.find((activity) => activity.id === orderId);
    });
  }

  render() {
    let component = <StudyActivitiesList {...this.props}/>;
    let activities;

    if (this.props.editing) {
      activities = this.order(this.props.activities);

      component = (
        <div>
          <StudyActivitiesForm
            activities={activities}
            onOrder={this.reorder.bind(this)}/>
          <FormControls
            onSave={this.save.bind(this)}
            onCancel={this.cancel.bind(this)}
            enabled={!this.state.submitting}/>
        </div>
      );
    }

    return component;
  }
}

module.exports = StudyActivities;
